import React from 'react';
import './Steppers.scss'; // SCSS for styling
import { Box, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { translation_hi } from '../../translations/translation_hi';
import { translation_en } from '../../translations/translation_en';

interface StepperProps {
    totalSteps: number;
    completedSteps: number;
    showPoints?: any;
    earndPoints?: any;
    totalPoints?: any;
}

const StepperGreen: React.FC<StepperProps> = ({ totalSteps, completedSteps, earndPoints,showPoints,totalPoints }) => {
    // const { t } = useTranslation();
    function translate(obj: any, path: string) {
  return path.split(".").reduce((acc, part) => acc && acc[part], obj);
}

// ✅ Choose translation based on saved language
const lang = localStorage.getItem("LANGUAGELOCALEKEY") || "en_IN";
const translations = lang.startsWith("hi") ? translation_hi : translation_en;

// ✅ Define t() function that mimics react-i18next’s syntax
const t = (key: string, vars?: Record<string, any>) => {
  let text = translate(translations, key) || key;
  if (vars) {
    Object.entries(vars).forEach(([k, v]) => {
      text = text.replace(`{{${k}}}`, String(v));
    });
  }
  return text;
};
    const steps = Array.from({ length: totalSteps }, (_, index) => index + 1);

    return (
        <Box>
            <div className="stepper-container">
                <div className={`connector ${completedSteps >= 1 ? 'completed' : ''}`} />
                {steps.map((step, index) => (
                    <React.Fragment key={step}>
                        <div className={'white-circle'}>
                            <div className={`step-circle ${index < completedSteps ? 'completed' : ''}`}>
                            </div>
                        </div>
                        {index < totalSteps - 1 && (
                            <div className={`connector ${index < completedSteps - 1 ? 'completed' : ''}`} />
                        )}
                    </React.Fragment>
                ))}
            </div>

            <Box sx={{display:"flex",justifyContent:"end"}}>
            <Box sx={{ display: "flex", alignItems: "center", justifyContent: "end", margin: "4px 0 5px", letterSpacing: " -0.06px" }}>
                <Typography sx={{ fontSize: "12px", lineHeight: "16px", fontWeight: "600", color: completedSteps > 0 ? '#000000' : '#000000' }}>
                    {/* {completedSteps}/{totalSteps} {t("varients")} */}
                    {`${t(`taskdetaitls.dot_code_scanning.label`,{completedSteps,totalSteps})}`}
                </Typography>
            </Box>
            {(totalPoints && showPoints) && <Box sx={{ display: "flex", alignItems: "center", justifyContent: "end", margin: "4px 12px 5px", letterSpacing: " -0.06px" }}>
                <Typography sx={{ fontSize: "12px", lineHeight: "16px", fontWeight: "600", color: completedSteps > 0 ? '#6CBC7F' : '#A7A8A9' }}>
                     {earndPoints}/{totalPoints} {t("pts")}</Typography>
            </Box>}
            </Box>
        </Box>
    );
};

export default StepperGreen;